module.exports = "/_next/static/images/Frame-38a739dc725afa4e58af9c9de5d7a9dc.webp";